import React, { useEffect, useState } from 'react';

import {
    Button, Popover, Stack, Text, TextInput,
} from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';

import ClearButton from './ClearButton';
import './styles.css';

function SearchSelect({
    label,
    fetchFn,
    fetchProps,
    onChange,
}) {
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [isDropdownActive, setDropdownActive] = useState(false);

    const [debouncedQuery] = useDebouncedValue(searchValue, 200);

    async function fetchData(query) {
        setIsLoading(true);

        try {
            const response = await fetchFn(query, fetchProps);

            setData(response);
        } catch (error) {
            // ignore
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData(searchValue);
    }, [debouncedQuery, fetchProps]);

    const handleChange = (selected) => {
        if (!onChange) {
            return;
        }

        const selectedItem = data.find((item) => item.value === selected);
        const defaultSelection = { value: selected };

        onChange(selectedItem || defaultSelection);
    };

    const handleSearch = (e) => {
        const { value } = e.currentTarget;

        if (value === searchValue) {
            return;
        }

        setSearchValue(value);
    };

    const handleClear = () => {
        setSearchValue('');
    };

    return (
        <div className="search-select__container">
            <Popover
                opened={!isLoading && isDropdownActive}
                position="bottom"
            >
                <Popover.Target>
                    <TextInput
                        className="search-select__input"
                        label={label}
                        onFocus={() => setDropdownActive(true)}
                        onBlur={() => setDropdownActive(false)}
                        onChange={handleSearch}
                        clearable
                        value={searchValue}
                        rightSection={isLoading ? '⏳' : <ClearButton isActive={searchValue.length} onClear={handleClear} />}
                    />
                </Popover.Target>
                <Popover.Dropdown
                    w="100% !important"
                    mah={300}
                    className="search-select__popover"
                >
                    <Stack>
                        {data?.length ? data.map((item) => (
                            <Button
                                key={item.value}
                                className="search-select__option"
                                onClick={() => handleChange(item.value)}
                                variant="subtle"
                                color="gray"
                                title={item.label}
                            >
                                {item.label}
                            </Button>
                        )) : (
                            <Text
                                size="sm"
                                w="100%"
                                align="center"
                            >
                                Ничего не найдено
                            </Text>
                        )}
                    </Stack>
                </Popover.Dropdown>
            </Popover>
        </div>
    );
}

export default SearchSelect;
